import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LOCALE, NAMESPACES, normalizeLocale, SUPPORTED_LOCALES } from 'civic-champs-translations/src'

import { LOCALE_STORAGE_KEY } from './constants'
import { detectBrowserLocale, readStoredLocale } from './detectLocale'
import { i18nResources } from './resources'
import { syncMomentLocale } from './syncMomentLocale'

const initialLocale = readStoredLocale() || detectBrowserLocale()

void i18n.use(initReactI18next).init({
  resources: i18nResources,
  lng: initialLocale,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: [...SUPPORTED_LOCALES],
  ns: [...NAMESPACES],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
})

syncMomentLocale(initialLocale)

i18n.on('languageChanged', lng => {
  syncMomentLocale(lng)
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, normalizeLocale(lng))
  } catch (_) {
    // ignore
  }
})

export default i18n
export { normalizeLocale }
